import { CITIZENSHIP } from '../constants/document';

export const isForeignCitizen = citizenship =>
  [CITIZENSHIP.FOREIGN_CITIZEN, CITIZENSHIP.NON_CITIZEN].includes(citizenship);
